module.exports = __webpack_public_path__ + "heart_broken.4cfe58c6.png";